// ==============================|| URL SEARCH PARAMS - HELPERE TIPATE ||============================== //
// Citire/scriere sigură a parametrilor de query: valorile invalide cad pe default,
// valorile egale cu default-ul NU se scriu în URL (URL-uri curate, partajabile).
// Funcții pure — testabile fără DOM/router.

/** Citește un string; gol/absent → fallback. */
export function readStringParam(params: URLSearchParams, key: string, fallback = ''): string {
	const raw = params.get(key);
	return raw === null || raw === '' ? fallback : raw;
}

/** Citește un întreg finit; absent/invalid → fallback. */
export function readNumberParam(
	params: URLSearchParams,
	key: string,
	fallback: number
): number {
	const raw = params.get(key);
	if (raw === null || raw.trim() === '') return fallback;
	const value = Number(raw);
	return Number.isFinite(value) && Number.isInteger(value) ? value : fallback;
}

/** Citește un boolean strict ("true"/"false"); orice altceva → fallback. */
export function readBooleanParam(
	params: URLSearchParams,
	key: string,
	fallback: boolean
): boolean {
	const raw = params.get(key);
	if (raw === 'true') return true;
	if (raw === 'false') return false;
	return fallback;
}

/** Citește o valoare dintr-un set permis (enum-like); necunoscut → fallback. */
export function readEnumParam<T extends string>(
	params: URLSearchParams,
	key: string,
	allowed: readonly T[],
	fallback: T | undefined
): T | undefined {
	const raw = params.get(key);
	if (raw !== null && (allowed as readonly string[]).includes(raw)) return raw as T;
	return fallback;
}

/** Scrie valoarea sau șterge cheia când e goală/nedefinită/null/false. */
export function setOptionalParam(
	params: URLSearchParams,
	key: string,
	value: string | number | boolean | null | undefined
): void {
	if (value === undefined || value === null || value === '' || value === false) {
		params.delete(key);
		return;
	}
	params.set(key, String(value));
}

/** Scrie valoarea doar când diferă de default — default-urile nu poluează URL-ul. */
export function setDefaultAwareParam(
	params: URLSearchParams,
	key: string,
	value: string | number | boolean | null | undefined,
	defaultValue: string | number | boolean | null | undefined
): void {
	if (value === defaultValue) {
		params.delete(key);
		return;
	}
	setOptionalParam(params, key, value);
}
